/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';

import './immo-teaser.scss';

import '../elements/immo-teaser-estate/css/immo-teaser-estate';
import '../elements/immo-teaser-text-box/css/immo-teaser-text-box';
import '../elements/immo-teaser-text-image/css/immo-teaser-text-image';
